
import { Component, Vue, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import lazyInject from '@/di';
import CarService from '@/services/car.service';

interface FormData {
  boss_phone: string;
  is_change_ad_phone: boolean;
  car_shop_code: string;
}

@Component
export default class TransferBossModal extends Vue {
  @Ref('formModel')
  formModel!: FormModel;

  @lazyInject(CarService)
  carService!: CarService;

  visible = false;
  confirmLoading = false;
  ModalText = '';
  form: FormData = {
    boss_phone: '',
    is_change_ad_phone: true,
    car_shop_code: '',
  };

  rules = {
    boss_phone: [
      { required: true, message: '请输入老板电话', trigger: 'blur' },
      {
        pattern: /^1[3-9]\d{9}$/,
        message: '请输入正确的手机号码',
        trigger: 'blur',
      },
    ],
  };

  handleCancel() {
    this.visible = false;
    this.formModel.resetFields();
  }

  handleOk() {
    this.formModel.validate(async (valid: boolean) => {
      if (valid) {
        const res = await this.carService.postCarShopTransferShopBoss(
          this.form,
        );
        if (res) {
          this.$message.success('操作成功');
          this.$emit('refresh');
          this.visible = false;
          this.formModel.resetFields();
        }
      }
    });
  }

  init(val: any) {
    this.form.car_shop_code = val;
    this.visible = true;
  }
}
